import Form from "../form";
import FormBuilderSortable from "../../../form_builder/models/formBuilderSortable";
import Guid from "~/helpers/guid";
import IRepo from "../../../../common/interfaces/repo";
import Repo from "../../../../common/state/modules/repo";
import FormDetailResourceValidation from "../../../../common/models/navigableValidations/formDetailResourceValidation";
import Validatable from "../../../../common/mixins/validatable";

export default class FormDetailResource extends Validatable(FormBuilderSortable) {
  name: string;
  url: string;

  static repo: IRepo<FormDetailResource> = new Repo<FormDetailResource>('formDetailResources', FormDetailResource);

  constructor(form: Form, sort_order: number = 1) {
    super();
    this.rootModel = form;
    this.parent = form;
    this.defineProperty('sort_order', form.nextSortOrderFor(this.rootName));
    this.defineProperty('name', '');
    this.defineProperty('url', '');
    this.defineProperty('client_id', Guid.create());
  }

  get rootName() {
    return "resources";
  }

  get displayName() {
    return "Resource";
  }

  //******************** VALIDATABLE ********************//
  _validation: FormDetailResourceValidation = new FormDetailResourceValidation(this);

  getDisplayName(propName: string, value?): string {
    const titleized = propName.split('_').map(p => p[0].toUpperCase() + p.slice(1)).join(' ');
    switch (propName) {
      default:
        return `Resource ${titleized}`;
    }
  }
  //******************** VALIDATABLE END ********************//
}
